var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"dataTile"},[_vm._v(_vm._s(_vm.$t('DataInfo.Overview')))]),_c('LeftConentBottom'),_c('div',{staticClass:"dataTile"},[_vm._v(_vm._s(_vm.$t('DataInfo.File')))]),_c('LeftDataBottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }